<template>
  <div>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="1" v-model="displayMode">
      <label class="form-check-label" for="exampleRadios1">
        引用
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="2" v-model="displayMode">
      <label class="form-check-label" for="exampleRadios2">
        重新編輯
      </label>
    </div>

    <div v-if="displayMode==='1'">
      <h1>引用</h1>
      <select class="form-control" id="selItems" name="selItems">
        <option></option>
        <option>腎水腫說明</option>
        <option>雙J管衛教</option>
      </select>
    </div>
    <div v-if="displayMode==='2'">
      <h1>標題</h1>
      <input type="text" class="form-control" id="name" name="name" placeholder="">
      如果有輸入標題，後續可以再引用它


      <MyCkEditor v-model="dataText" height="600px" ></MyCkEditor>

    </div>


  </div>
</template>

<script>
import MyCkEditor from "@/views/taylorAdmin/component/MyCkEditor";
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
export default {
  components: {MyCkEditor},
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      displayMode:"1",
      formData: {
        name: "",
      },
      dataText:"",

      datas:[
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act01.jpg",
          date:"2021-10-20",
          text:"第1222次例會",
          desc:"內文說明活動說明照片說明",
        },
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act02.jpg",
          date:"2021-10-20",
          text:"第1221次例會",
          desc:"內文說明活動說明照片說明",
        },
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act03.jpg",
          date:"2021-10-20",
          text:"第1220次例會",
          desc:"內文說明活動說明照片說明",
        },
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act04.jpg",
          date:"2021-10-20",
          text:"第1219次例會",
          desc:"內文說明活動說明照片說明",
        },
      ]
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    submit(){
      for (let i = 0; i < this.datas.Details.length; i++) {
        let item = this.datas.Details[i];

        if (item.Year===""){
          util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
          return;
        }
        if (item.Month===""){
          util.showErrorMessage("第"+i+1+" 行，「月」為必填欄位")
          return;
        }
        if (item.Type===""){
          util.showErrorMessage("第"+i+1+" 行，「幣別」為必填欄位")
          return;
        }
        if (item.Rate===""){
          util.showErrorMessage("第"+i+1+" 行，「匯率」為必填欄位")
          return;
        }
      }

      // apiGPK.api_Save_datas(this.datas.SystemId,"",this.datas).then((data)=>{
      //   util.ShowMessage('儲存成功')
      // })
    },

    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Insert(currentItem){
      // let newItem={
      //   Id:util.uuid(),
      //   imgSrc:"",
      //   date:"2021-10-20",
      //   text:"",
      //   desc:"",
      // }
      //
      // arrayUtil.orderInsert(newItem,currentItem,this.datas,"Id","OrderKey")
      //
      this.$router.push({
        path: "/contentDetailEdit",
        // path: item.url,
      });
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.Id===item.Id);
    },

  },
  mounted() {
    //this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
